import Vue from 'vue'
import App from './App'
import store from './vuex'

// Import all related imports
import Packages from './packages'

new Packages(new Vue())

Vue.config.productionTip = false

import router from './router'

global.main_vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})